import { isEmptyString } from '@/utils/string';
import { isSendingBarred, isSendingVerified, type Domain } from '@/services/db/domain/entity';
import type { DomainsList } from '@/services/db/domain/queries';

function hasDomainName(domain: Domain): boolean {
  return !isEmptyString(domain.domain);
}

// Barred excluded: preferring one would pick a sender whose every send fails.
function isVerifiedDomain(domain: Domain): boolean {
  return isSendingVerified(domain);
}

function selectDomain(domains: readonly Domain[]): Domain | null {
  const namedDomains = domains.filter(hasDomainName);
  // Barred skipped in the fallback too: it lands in the snippet's `from`, so
  // handing one back guarantees failure. Better nothing.
  const candidates = namedDomains.filter((domain) => !isSendingBarred(domain));

  return candidates.find(isVerifiedDomain) ?? candidates[0] ?? null;
}

export function selectSandboxSendingDomain(data: DomainsList): string | null {
  return selectDomain(data.domains)?.domain ?? null;
}
